import http from './httpService';

const apiEndPoint = '/trade-responses';

function tradeResponseUrl(id) {
  return `${apiEndPoint}/${id}`;
}

export function getTradeResponses() {
  return http.get(apiEndPoint);
}

export function getTradeResponse(tradeResponseId) {
  return http.get(tradeResponseUrl(tradeResponseId));
}

export function saveTradeResponse(tradeResponse) {
  if (tradeResponse._id) {
    const body = { ...tradeResponse };
    delete body._id;
    return http.put(tradeResponseUrl(tradeResponse._id), body);
  }

  return http.post(apiEndPoint, tradeResponse);
}

export function deleteTradeResponse(tradeResponseId) {
  return http.delete(tradeResponseUrl(tradeResponseId));
}
